import { render, staticRenderFns } from "./card-goods.vue?vue&type=template&id=2401d197&scoped=true"
import script from "./card-goods.vue?vue&type=script&lang=js"
export * from "./card-goods.vue?vue&type=script&lang=js"
import style0 from "./card-goods.vue?vue&type=style&index=0&id=2401d197&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2401d197",
  null
  
)

export default component.exports